import React from "react";
import { connectRefinementList } from "react-instantsearch-dom";
import SearchBox from "~components/organisms/search/search_input/search_input";
import JobSearchRefineSelectDepartment from "../search_jobs_refine_select_department/search_jobs_refine_select_department";
import JobSearchRefineSelectLocation from "../search_jobs_refine_select_location/search_jobs_refine_select_location";

const SEARCH_PLACEHOLDER_STRING = "Search...";

const LocationRefineSelect = connectRefinementList(
  JobSearchRefineSelectLocation
);
const DepartmentRefineSelect = connectRefinementList(
  JobSearchRefineSelectDepartment
);
const SearchJobsFields = () => {
  return (
    <>
      <SearchBox
        placeholder={SEARCH_PLACEHOLDER_STRING}
        leadingIcon="icon_search"
        size="lg"
      />
      <LocationRefineSelect attribute="office" />
      <DepartmentRefineSelect attribute="department" />
    </>
  );
};

export default SearchJobsFields;
